<template>
    <div class="dividLine">
      <div v-if="mode=='none'" class="hr1"></div>
      <div v-if="mode=='left'" class="hr2">
        <span class="hr21"></span>
        <span style="margin: 0 20px;font-size: 1.2rem;color: #008080;">{{text}}</span>
        <span class="hr22"></span>
      </div>
      <div v-if="mode=='right'" class="hr3">
        <span class="hr31"></span>
        <span style="margin: 0 20px;font-size: 1.2rem;color: #008080;">{{text}}</span>
        <span class="hr32"></span>
      </div>
    </div>
</template>

<script>

export default {
  data() {
    return {
      
    }
  },
  props: {
    mode:{
      type:String,      //类型
      required:false,   //是否必填
      default:'none'     //none:没有文字，left:文字在左侧，right:文字在右侧
    },
    text:{
      type:String,
      required:false,
      default:''
    },
  },
  methods:{

  },
  
}
</script>

<style>
.hr1 {
  border-bottom: 1px solid rgb(205, 204, 204);
}
.hr2{
  display: flex;
  align-items: center;
  height: 40px;
}
.hr21 {
  width: 10%;
  border-bottom: 1px solid #008080;
  display: inline-block;
}
.hr22 {

  border-bottom: 1px solid #008080;
  display: inline-block;
  flex: 1;
}
.hr3{
  display: flex;
  align-items: center;
  height: 40px;
}
.hr31 {
  width: 84%;
  border-bottom: 1px solid #008080;
  display: inline-block;
}
.hr32 {

  border-bottom: 1px solid #008080;
  display: inline-block;
  flex: 1;
}
</style>